import { useEffect, useState } from "react";
import { getSupabase } from "@/lib/supabase-lazy";

/** Interruptor del Back Office (`app_settings.plan_lite_enabled`). Por defecto Lite está desactivado. */
let cached: Promise<boolean> | undefined;

export function fetchLiteEnabled(force = false): Promise<boolean> {
  if (!cached || force) {
    cached = (async () => {
      try {
        const supabase = await getSupabase();
        const { data } = await supabase.from("app_settings").select("value").eq("key", "plan_lite_enabled").maybeSingle();
        const v = data?.value as unknown;
        return v === true || v === "true";
      } catch {
        return false;
      }
    })();
  }
  return cached;
}

export function useLiteEnabled(): boolean {
  const [enabled, setEnabled] = useState(false);
  useEffect(() => {
    let alive = true;
    fetchLiteEnabled().then((v) => alive && setEnabled(v));
    return () => { alive = false; };
  }, []);
  return enabled;
}
